import styled from 'styled-components'
import Text from '../atoms/Text'
import conversation from '../../assets/talking.png'
import pencil from '../../assets/pencil.png'
import wordCard from '../../assets/flash-card.png'

const Container = styled.div`
  width: 100%;
  margin-top: 36px;
`
const MenuWrapper = styled.div`
  width: 100%;
  margin-top: 12px;
`
const FullMenu = styled.div`
  width: 100%;
  min-height: 96px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 16px;
  background-color: ${(props) => props.theme.colors.neutral[100]};
  border: none;
  border-radius: 10px;
  cursor: pointer;
  img {
    width: 48px;
    height: 48px;
  }
`
const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: 8px;
  word-break: keep-all;
`
const HalfMenuWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
`
const HalfMenu = styled.div`
  width: calc(50% - 6px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px 16px;
  background-color: ${(props) => props.theme.colors.neutral[100]};
  border: none;
  border-radius: 10px;
  cursor: pointer;
  img {
    width: 42px;
    height: 42px;
    align-self: flex-end;
    margin-top: 8px;
  }
`
const RecordGroup = ({ onMenuClick }) => {
  return (
    <Container>
      <Text variant="headline2" weight="bold">우리 아이 말 기록</Text>
      <MenuWrapper>
        <FullMenu onClick={() => onMenuClick('/conversation-word')}>
          <TextWrapper>
            <Text variant="headline3" weight="bold">대화 기록</Text>
            <Text variant="body2" weight="medium" color="alternative">
              아이와 나눈 대화를 녹음해 말 사용을 기록해요.
            </Text>
          </TextWrapper>
          <img src={conversation}/>
        </FullMenu>
        <HalfMenuWrapper>
          <HalfMenu onClick={() => onMenuClick('/words/new')}>
            <TextWrapper>
              <Text variant="headline3" weight="bold">아는 단어 기록</Text>
              <Text variant="body2" weight="medium" color="alternative">
                이미 알고 있는 아이의 말을 바로 기록해요.
              </Text>
            </TextWrapper>
            <img src={pencil} />
          </HalfMenu>
          <HalfMenu onClick={() => onMenuClick('/card-word')}>
            <TextWrapper>
              <Text variant="headline3" weight="bold">단어 카드 기록</Text>
              <Text variant="body2" weight="medium" color="alternative">
                낱말 카드로 단어 발음을 기록해요.  
              </Text>
            </TextWrapper>
            <img src={wordCard} />
          </HalfMenu>
        </HalfMenuWrapper>
      </MenuWrapper>
    </Container>
  )
}

export default RecordGroup
